// src/components/DiffView.js
import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";

const DiffView = ({ analysis, accepted, setAccepted }) => {
  return (
    <Stack spacing={3} sx={{ width: '100%' }}>
      <Typography variant="h6">Suggested Changes</Typography>
      {analysis.suggestions.map((sug, idx) => (
        <Card
          key={idx}
          variant={accepted[idx] ? "outlined" : "elevation"}
          sx={{
            background: accepted[idx] ? "#e6ffe6" : "#fff",
            borderLeft: accepted[idx] ? "4px solid #00b050" : "4px solid #1976d2",
          }}
        >
          <CardContent>
            <Typography variant="subtitle2" color="text.secondary">
              {sug.section}
            </Typography>
            <Typography variant="body2" gutterBottom>
              <b>Original:</b> {sug.original}
            </Typography>
            <Typography variant="body2">
              <b>Suggestion:</b> {sug.suggestion}
            </Typography>
            <Button
              size="small"
              color={accepted[idx] ? "success" : "primary"}
              onClick={() =>
                setAccepted(prev => ({ ...prev, [idx]: !prev[idx] }))
              }
              sx={{ mt: 1 }}
              variant={accepted[idx] ? "contained" : "outlined"}
            >
              {accepted[idx] ? "Reject" : "Accept"}
            </Button>
          </CardContent>
        </Card>
      ))}
    </Stack>
  );
};

export default DiffView;
